var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23C9.55228 23 10 22.531 10 21.9524C10 21.3738 9.55228 20.9048 9 20.9048C8.44772 20.9048 8 21.3738 8 21.9524C8 22.531 8.44772 23 9 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C20.5523 23 21 22.531 21 21.9524C21 21.3738 20.5523 20.9048 20 20.9048C19.4477 20.9048 19 21.3738 19 21.9524C19 22.531 19.4477 23 20 23Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5L7.68 15.0276C7.77144 15.5099 8.02191 15.9432 8.38755 16.2516C8.75318 16.5599 9.2107 16.7237 9.68 16.7143H19.4C19.8693 16.7237 20.3268 16.5599 20.6925 16.2516C21.0581 15.9432 21.3086 15.5099 21.4 15.0276L23 6.23809H6",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5L7.68 15.0276C7.77144 15.5099 8.02191 15.9432 8.38755 16.2516C8.75318 16.5599 9.2107 16.7237 9.68 16.7143H19.4C19.8693 16.7237 20.3268 16.5599 20.6925 16.2516C21.0581 15.9432 21.3086 15.5099 21.4 15.0276L23 6.23809H6M10 21.9524C10 22.531 9.55228 23 9 23C8.44772 23 8 22.531 8 21.9524C8 21.3738 8.44772 20.9048 9 20.9048C9.55228 20.9048 10 21.3738 10 21.9524ZM21 21.9524C21 22.531 20.5523 23 20 23C19.4477 23 19 22.531 19 21.9524C19 21.3738 19.4477 20.9048 20 20.9048C20.5523 20.9048 21 21.3738 21 21.9524Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e94035487f0868cc79a1c4a031ee0386.svg";
export { ForwardRef as ReactComponent };